import { authApi } from '../api/authApi'

export const forgotPassword = async (email: string) => {
  try {
    const response = await authApi.forgotPassword(email)
    return response.data
  } catch (error) {
    console.error('Error requesting password reset', error)
    throw error
  }
}
